import { Button, Form, Select, Spin } from "antd";
import React, { useEffect, useRef, useState } from "react";
import {
    aadharPattern,
    dispatchtoast,
    emailPattern,
    filterOption,
    getLocalStorageItem,
    mobilePattern,
    panPattern,
} from "../../../Utils";
import { setselectedTab } from "../../../Store/B2bslice";
import { AddFundapi, bankotpapi, bankotpverify, getaccounttype, submitKyc } from "../../../ApiServices/Apifun";
import { useDispatch, useSelector } from "react-redux";
import VerifyModal from "../../../Common/VerifyModal";
import { Globalendpoints } from "../../../ApiServices/global";
import CommonInput from "../../../Common/CommonInput";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import BankForm from "./BankForm";
import Otp from "../../Auth/Otp";

const AddYourBankAccount = () => {
    const navigate = useNavigate();
    const [accout_type, setaccout_type] = useState([]);
    const [fields, setFields] = useState([]);
    const [isLoading, setLoading] = useState(false);
    const [mandatory, setmandatory] = useState(false);
    const [form] = Form.useForm();
    const formref = useRef();
    const dispatch = useDispatch();
    const checkKyc = useSelector((state) => state.B2B.profileDetail);
    const [isOtp, setIsOtp] = useState(false);

    const [isbankForm, setIsbankForm] = useState(false);
    const [otp_uid, setotp_uid] = useState("");
    const [btnLoading, setBtnLoading] = useState(false);

    console.log(fields);


    const handleSubmit = (val) => {
        setBtnLoading(true);
        const formdata = new FormData();
        Object.entries(val).map(([key, value]) =>
            formdata.append(key, value)
        );
        bankotpapi(formdata)
            .then((res) => {
                if (res.status) {
                    dispatchtoast(res.message)
                    setIsOtp(true);
                    setotp_uid(res?.otp_uid)
                }
            })
            .catch((err) => console.log(err))
            .finally(() => setBtnLoading(false));
    };
    const handleVerify = (val) => {
        setBtnLoading(true);
        const formdata = new FormData();
        formdata.append("mobile", form.getFieldValue("mobile"));
        formdata.append("otp_uid", otp_uid);

        Object.entries(val).map(([key, value]) =>
            formdata.append(key, value)
        );
        bankotpverify(formdata)
            .then((res) => {
                if (res.status) {
                    dispatchtoast(res.message);
                    setIsbankForm(true)
                }
            })
            .catch((err) => console.log(err))
            .finally(() => setBtnLoading(false));
    };
    useEffect(() => {
        dispatch(setselectedTab("2.909"));
    }, []);
    useEffect(() => {

        setLoading(true);
        getaccounttype()
            .then((res) => {
                if (res.status) {
                    const accountype = res.data.account_types.map((item, index) => {
                        return {
                            label: item.account_name,
                            value: item.slug,
                            key: index,
                        };
                    });
                    setaccout_type(accountype)
                } else {
                    dispatchtoast(res.data.msg, true);
                }
            })
            .catch((err) => console.log(err))
            .finally(() => setLoading(false));

    }, []);
    return (
        <>
            {isbankForm ?
                <BankForm otp={form.getFieldValue().otp} otp_uid={otp_uid} account_type={fields.circle} mandatory={fields.circle == "loan-application"} />
                :
                <div className="grid grid-cols-1 md:grid-cols-2 place-items-start">
                    <Spin className="w-full" spinning={isLoading}>
                        <div className="prepaid w-full animate-slide-in bg-white rounded-3xl  shadow-normal  p-5">
                            <p className="font-bold text-[15px] mb-2">Open S/B Account</p>
                            <div className="selectionFields ">

                                {isOtp ?
                                    <Form
                                        name="basic"
                                        form={form}
                                        ref={formref}
                                        onFinishFailed={(err) => console.log(err)}
                                        onFinish={(val) => handleVerify(val)}
                                    >
                                        <Form.Item
                                            name={`otp`}
                                            label={"Enter OTP"}
                                            labelCol={{ span: 24 }}
                                            rules={[
                                                {
                                                    required: true,
                                                    message: "Enter OTP!",
                                                },
                                                {
                                                    whitespace: true,
                                                    message: "Field cannot contain only blank spaces",
                                                },
                                            ]}
                                        >
                                            <CommonInput
                                                placeholder="Enter Your OTP"
                                                name="otp"
                                            />
                                        </Form.Item>{" "}


                                        <Form.Item>
                                            <Button
                                                htmlType="submit"
                                                loading={btnLoading}
                                                className="bg-primary mt-2 w-full border-none rounded-md h-9 text-center text-white flex justify-center items-center font-bold text-md cursor-pointer"
                                            >
                                                Verify OTP
                                            </Button>
                                        </Form.Item>{" "}
                                    </Form>
                                    :
                                    <Form
                                        name="basic"
                                        form={form}
                                        ref={formref}
                                        onFinishFailed={(err) => console.log(err)}
                                        onFinish={(val) => fields.circle == "loan-application" ? setIsbankForm(true) : handleSubmit(val)}
                                    >
                                        <Form.Item
                                            name={`account_type`}
                                            label={"Select Account Type"}
                                            labelCol={{ span: 24 }}
                                            rules={[
                                                {
                                                    required: true,
                                                    message: "Select Account Type!",
                                                },
                                                {
                                                    whitespace: true,
                                                    message: "Field cannot contain only blank spaces",
                                                },
                                            ]}
                                        >
                                            <Select
                                                showSearch
                                                placeholder="Select Account Type"
                                                value={accout_type.account_name}
                                                filterOption={filterOption}
                                                onChange={(val) => {
                                                    setFields({ ...fields, circle: val });
                                                }}
                                                className="w-full mb-2"
                                                options={accout_type}
                                            />

                                        </Form.Item>{" "}

                                        <Form.Item
                                            name={`mobile`}
                                            label={"Enter Mobile No."}
                                            labelCol={{ span: 24 }}
                                            rules={[
                                                {
                                                    required: true,
                                                    message: "Enter Mobile No.!",
                                                },
                                                {
                                                    whitespace: true,
                                                    pattern: mobilePattern,
                                                    message: "Field cannot contain only blank spaces",
                                                },
                                            ]}
                                        >
                                            <CommonInput
                                                placeholder="Enter Your Mobile No."
                                                name="mobile"
                                            />
                                        </Form.Item>




                                        <Form.Item>
                                            <Button
                                                htmlType="submit"
                                                loading={btnLoading}
                                                className="bg-primary mt-2 w-full border-none rounded-md h-9 text-center text-white flex justify-center items-center font-bold text-md cursor-pointer"
                                            >
                                                {fields.circle == "loan-application" ? "Next" : "Send OTP"}
                                            </Button>
                                        </Form.Item>{" "}
                                    </Form>

                                }


                            </div>
                        </div>

                    </Spin>

                </div>
            }


        </>
    );
};

export default AddYourBankAccount;